module.exports = __webpack_public_path__ + "static/media/sample_vin_bulk_upload_last_mile.1c27003e.csv";